import React from 'react';
import CustomFilter from './Filter/CustomFilter';
import { LatencyContextProvider } from './context/Context';
import DeviceStateCard from './DeviceHealthCard/DeviceStateCard';
import LatencyTrendCard from './LatencyTrendCard/LatencyTrendCard';
import LayerLatencyTable from './LayerLatencyCard/LayerLatencyTable';

const LatencyHome = () => {
    return (
        // pb-4: breathing room between the last card and the page end
        <div className="pb-4">
            <LatencyContextProvider>
                <CustomFilter />
                <DeviceStateCard />
                <LatencyTrendCard />
                <LayerLatencyTable />
            </LatencyContextProvider>
        </div>
    );
}

export default LatencyHome;
